import React, { useEffect } from "react";
import { FormField } from "../formFieldGenerator/FormField";
import { getFieldProperties } from "../../../utils/formGenUtils/getFieldProperties";
import { IFieldInstance } from "../../../types/fieldInstance.interface";
import {
  fieldTypes,
  getInitialValue,
} from "../../../utils/formGenUtils/getInitialValues";
import { useFormikContext } from "formik";

interface IFieldArrayFieldProps {
  mainFieldName: string;
  index: number;
  field: IFieldInstance;
  recordViewModel: any;
  getError: any;
  selectOptions: any;
  record: any;
  parentField: string;
  shouldCleanupField: boolean;
  allWoundFields?: IFieldInstance[];
}

const FieldArrayField = ({
  field,
  mainFieldName,
  index,
  recordViewModel,
  getError,
  selectOptions,
  record,
  parentField,
  shouldCleanupField,
  allWoundFields,
}: IFieldArrayFieldProps) => {
  const {
    showToggleBox,
    typeControlName,
    typeControlLabel,
    inputName,
    secondaryBPFieldName,
    checkboxFieldName,
    checkboxLabel,
  } = getFieldProperties(field, mainFieldName);
  const formik = useFormikContext();
  const rlField = {
    ...field,
    fieldName: `${mainFieldName}[${index}].${field.fieldName}`,
  };
  const rlFormattedNames = {
    typeControlName: `${mainFieldName}[${index}].${typeControlName}`,
    inputName: `${mainFieldName}[${index}].${inputName}`,
    secondaryBPFieldName: `${mainFieldName}[${index}].${secondaryBPFieldName}`,
    checkboxFieldName: `${mainFieldName}[${index}].${checkboxFieldName}`,
  };
  const viewModelValue = recordViewModel && recordViewModel[rlField.id];
  const initialValue = getInitialValue(
    rlField.fieldType as keyof typeof fieldTypes
  );
  useEffect(() => {
    return () => {
      if (shouldCleanupField) {
        formik.setFieldValue(rlField.fieldName, initialValue);
      }
    };
  }, [shouldCleanupField]);

  return (
    <React.Fragment key={`${rlField.fieldName}-${rlField.id}`}>
      {!!viewModelValue && (
        <FormField
          key={`${rlField.fieldName}-${rlField.id}`} // replace with UUID ?
          instance={rlField}
          getError={getError}
          showToggleBox={showToggleBox}
          typeControlName={rlFormattedNames.typeControlName}
          typeControlLabel={typeControlLabel}
          inputName={rlFormattedNames.inputName}
          secondaryBPFieldName={rlFormattedNames.secondaryBPFieldName}
          checkBoxFieldName={rlFormattedNames.checkboxFieldName}
          checkBoxLabel={checkboxLabel}
          disabled={false}
          rlParentFieldName={mainFieldName}
          allWoundFields={allWoundFields || []}
        />
      )}
    </React.Fragment>
  );
};

export default FieldArrayField;
